var notFound = "/home/circleci/app/src/assets/img/404-toon.png";

export { notFound as default };
